import apiFetech from "../configs/axios";

export class CartServices {
  /**
   *  ## ADD Meal To Cart
   * @param {Symbol} {mealID,quantity,options}
   */
  static addMealTocart({data,token=null}) {
  
    var config = {
      method: "post",
      url: "cart/addToCart",
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: data
    };
    return apiFetech(config);
  } 
 
  // ** Get Cart Items
  static getCart() {
    var config = {
      method: "get",
      url: "order/cart",
      // headers: {
      //   Authorization: `Bearer ${token}`
      // }
    };
    return apiFetech(config);
  }

  // ** Get Cart Items
  static cartUpdate({ token,cartID,formData }) {
    var config = {
      method: "post",
      url: `cart/updateMealCart/${cartID}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      data:formData
    };
    return apiFetech(config);
  }

  static cartDelete({mealID}){
    var config = {
      method: "delete",
      url: `cart/${mealID}`,
      // headers: {
      //   Authorization: `Bearer ${token}`
      // },
    };
    return apiFetech(config);
  }
}
